import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function env() {
  return (
    process.env.VERCEL_ENV ||
    process.env.NEXT_PUBLIC_VERCEL_ENV ||
    process.env.NODE_ENV ||
    process.env.NEXT_PUBLIC_NODE_ENV
  )
}

export function isDev() {
  return env() === 'development'
}

export function isProd() {
  return env() === 'production'
}

export function isPreview() {
  return env() === 'preview'
}
